module.exports = "<div class=\"form valign\">\n    <div class=\"headline\">Reset email sent!</div>\n    <div class=\"horizontal-seperator\"></div>\n    <span class=\"sub-heading\">Please check your email's inbox for a link to reset your password</span>\n    <span class=\"link return text-center\" [routerLink]=\"['/login']\"><i class=\"material-icons\">keyboard_backspace</i>Return to login screen</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/forms/confirm-email-sent.component.html
// module id = ./src/app/login/forms/confirm-email-sent.component.html
// module chunks = main